export const festivalData = {
  january: [
    {
      image: require("../../assets/image/Festival/1.jpg"),
      title: "New Year",
      date: "1 January 2026",
      tithi: "Trayodashi",
      paksha: "Shukla"
    },
    {
      image: require("../../assets/image/Festival/2.jpg"),
      title: "Shakambhari Purnima",
      date: "3 January 2026",
      tithi: "Purnima",
      paksha: "Shukla"
    },
    {
      image: require("../../assets/image/Festival/3.jpg"),
      title: "Sakat Chauth",
      date: "6 January 2026",
      tithi: "Tritiya",
      paksha: "Krishna"
    },
    {
      image: require("../../assets/image/Festival/4.jpg"),
      title: "Swami Vivekananda Jayanti",
      date: "12 January 2026",
      tithi: "Navami",
      paksha: "Krishna"
    },
    {
      image: require("../../assets/image/Festival/5.jpg"),
      title: "Lohri",
      date: "13 January 2026",
      tithi: "Dashami",
      paksha: "Krishna"
    },
    {
      image: require("../../assets/image/Festival/6.jpg"),
      title: "Makara Sankranti",
      date: "14 January 2026",
      tithi: "Ekadashi",
      paksha: "Krishna"
    },
    {
      image: require("../../assets/image/Festival/7.jpg"),
      title: "Mauni Amavas",
      date: "18 January 2026",
      tithi: "Amavasya",
      paksha: "Krishna"
    },
    {
      image: require("../../assets/image/Festival/8.jpg"),
      title: "Ganesha Jayanti",
      date: "22 January 2026",
      tithi: "Chaturthi",
      paksha: "Shukla"
    },
    {
      image: require("../../assets/image/Festival/9.jpg"),
      title: "Vasant Panchami",
      date: "23 January 2026",
      tithi: "Panchami",
      paksha: "Shukla"
    },
    {
      image: require("../../assets/image/Festival/10.jpg"),
      title: "Republic Day",
      date: "26 January 2026",
      tithi: "Ashtami",
      paksha: "Shukla"
    }
  ],
february: [
  {
    image: require("../../assets/image/Festival/11.jpg"),
    title: "Sankashti Ganesh Chaturthi",
    date: "5 February 2026",
    tithi: "Chaturthi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/12.jpg"),
    title: "Janaki Jayanti",
    date: "10 February 2026",
    tithi: "Navami",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/13.jpg"),
    title: "Kumbh Sankranti",
    date: "13 February 2026",
    tithi: "Dwadashi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/14.jpg"),
    title: "Valentines Day",
    date: "14 February 2026",
    tithi: "Trayodashi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/15.jpg"),
    title: "Mahashivratri",
    date: "15 February 2026",
    tithi: "Chaturdashi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/16.jpg"),
    title: "Ramakrishna Jayanti",
    date: "19 February 2026",
    tithi: "Dwitiya",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/17.jpg"),
    title: "Durgashtami Vrat",
    date: "24 February 2026",
    tithi: "Ashtami",
    paksha: "Shukla"
  }
],
march: [
  {
    image: require("../../assets/image/Festival/18.jpg"),
    title: "Holika Dahan",
    date: "03 March 2026",
    tithi: "Purnima",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/19.jpg"),
    title: "Holi",
    date: "04 March 2026",
    tithi: "Pratipada",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/20.jpg"),
    title: "Sankashti Ganesh Chaturthi",
    date: "6 March 2026",
    tithi: "Chaturthi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/21.jpg"),
    title: "International Womens Day",
    date: "08 March 2026",
    tithi: "Shashthi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/22.jpg"),
    title: "Budha Ashtami Vrat",
    date: "11 March 2026",
    tithi: "Ashtami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/23.jpg"),
    title: "Chaitra Navratri",
    date: "19 March 2026",
    tithi: "Pratipada",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/24.jpg"),
    title: "Gauri Puja",
    date: "21 March 2026",
    tithi: "Tritiya",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/25.jpg"),
    title: "Budha Ashtami Vrat",
    date: "25 March 2026",
    tithi: "Ashtami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/26.jpg"),
    title: "Ram Navami",
    date: "26 March 2026",
    tithi: "Navami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/27.jpg"),
    title: "Mahavir Jayanti",
    date: "30 March 2026",
    tithi: "Trayodashi",
    paksha: "Shukla"
  }
],
april: [
  {
    image: require("../../assets/image/Festival/28.jpg"),
    title: "Hanuman Jayanti",
    date: "2 April 2026",
    tithi: "Purnima",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/29.jpg"),
    title: "Good Friday",
    date: "3 April 2026",
    tithi: "Dwitiya",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/30.jpg"),
    title: "Sankashti Ganesh Chaturthi",
    date: "5 April 2026",
    tithi: "Chaturthi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/31.jpg"),
    title: "World Health Day",
    date: "7 April 2026",
    tithi: "Shashthi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/32.jpg"),
    title: "Ambedkar Jayanti",
    date: "14 April 2026",
    tithi: "Dwadashi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/33.jpg"),
    title: "Parashurama Jayanti",
    date: "19 April 2026",
    tithi: "Tritiya",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/34.jpg"),
    title: "Ganga Saptami",
    date: "23 April 2026",
    tithi: "Saptami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/35.jpg"),
    title: "Durga Ashtami Navratri",
    date: "24 April 2026",
    tithi: "Ashtami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/36.jpg"),
    title: "Sita Navami",
    date: "25 April 2026",
    tithi: "Navami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/37.jpg"),
    title: "Narasimha Jayanti",
    date: "30 April 2026",
    tithi: "Chaturdashi",
    paksha: "Shukla"
  }
],
may: [
  {
    image: require("../../assets/image/Festival/38.jpg"),
    title: "Buddha Purnima",
    date: "1 May 2026",
    tithi: "Purnima",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/39.jpg"),
    title: "Narada Jayanti",
    date: "2 May 2026",
    tithi: "Pratipada",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/40.jpg"),
    title: "Sankashti Ganesh Chaturthi",
    date: "5 May 2026",
    tithi: "Chaturthi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/41.jpg"),
    title: "Rabindranath Tagores Birth Anniversary",
    date: "7 May 2026",
    tithi: "Shashthi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/42.jpg"),
    title: "Mothers Day",
    date: "10 May 2026",
    tithi: "Navami",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/43.jpg"),
    title: "Shani Jayanti",
    date: "16 May 2026",
    tithi: "Amavasya",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/44.jpg"),
    title: "Durgashtami Vrat Navratri",
    date: "23 May 2026",
    tithi: "Ashtami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/45.jpg"),
    title: "Ganga Dussehra",
    date: "25 May 2026",
    tithi: "Dashami",
    paksha: "Shukla"
  }
],
june: [
  {
    image: require("../../assets/image/Festival/46.jpg"),
    title: "World Environment Day",
    date: "5 June 2026",
    tithi: "Panchami",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/47.jpg"),
    title: "Maharana Pratap Jayanti",
    date: "17 June 2026",
    tithi: "Tritiya",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/48.jpg"),
    title: "Fathers Day",
    date: "21 June 2026",
    tithi: "Saptami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/49.jpg"),
    title: "Durgashtami Vrat",
    date: "22 June 2026",
    tithi: "Ashtami",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/50.jpg"),
    title: "Nirjala Ekadashi",
    date: "25 June 2026",
    tithi: "Ekadashi",
    paksha: "Shukla"
  }
],
july: [
  {
    image: require("../../assets/image/Festival/51.jpg"),
    title: "Sankashti Ganesh Chaturthi",
    date: "3 July 2026",
    tithi: "Chaturthi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/52.jpg"),
    title: "Bhaumvati Amavasya",
    date: "14 July 2026",
    tithi: "Amavasya",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/53.jpg"),
    title: "Gupt Navratri begins",
    date: "15 July 2026",
    tithi: "Pratipada",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/54.jpg"),
    title: "Jagannath Rath Yatra",
    date: "16 July 2026",
    tithi: "Dwitiya",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/55.jpg"),
    title: "Durgashtami Vrat",
    date: "21 July 2026",
    tithi: "Ashtami",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/56.jpg"),
    title: "Guru Purnima",
    date: "29 July 2026",
    tithi: "Purnima",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/57.jpg"),
    title: "Kanwar Yatra",
    date: "30 July 2026",
    tithi: "Pratipada",
    paksha: "Krishna"
  }
],

august: [
  {
    image: require("../../assets/image/Festival/58.jpg"),
    title: "Sankashti Ganesh Chaturthi",
    date: "2 August 2026",
    tithi: "Chaturthi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/59.jpg"),
    title: "Budha Ashtami Vrat",
    date: "5 August 2026",
    tithi: "Saptami",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/60.jpg"),
    title: "Independence Day",
    date: "15 August 2026",
    tithi: "Tritiya",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/61.jpg"),
    title: "Nag Panchami",
    date: "17 August 2026",
    tithi: "Panchami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/62.jpg"),
    title: "Tulsidas Jayanti",
    date: "19 August 2026",
    tithi: "Saptami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/63.jpg"),
    title: "Durgashtami Vrat",
    date: "20 August 2026",
    tithi: "Ashtami",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/64.jpg"),
    title: "Onam",
    date: "26 August 2026",
    tithi: "Chaturdashi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/65.jpg"),
    title: "Raksha Bandhan",
    date: "28 August 2026",
    tithi: "Purnima",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/66.jpg"),
    title: "Kajari Teej",
    date: "31 August 2026",
    tithi: "Chaturthi",
    paksha: "Krishna"
  }
],
september: [
  {
    image: require("../../assets/image/Festival/67.jpg"),
    title: "Shri Krishna Janmashtami",
    date: "4 September 2026",
    tithi: "Ashtami",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/68.jpg"),
    title: "Teachers Day",
    date: "5 September 2026",
    tithi: "Navami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/69.jpg"),
    title: "Hartalika Teej",
    date: "14 September 2026",
    tithi: "Chaturdashi",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/70.jpg"),
    title: "Kanya Sankranti",
    date: "17 September 2026",
    tithi: "Shashthi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/71.jpg"),
    title: "Mahalakshmi Vrat",
    date: "18 September 2026",
    tithi: "Ashtami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/72.jpg"),
    title: "Radha Ashtami",
    date: "19 September 2026",
    tithi: "Ashtami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/73.jpg"),
    title: "Anant Chaturdashi",
    date: "25 September 2026",
    tithi: "Chaturdashi",
    paksha: "Shukla"
  }
],
october: [
  {
    image: require("../../assets/image/Festival/74.jpg"),
    title: "Gandhi Jayanti",
    date: "2 October 2026",
    tithi: "Saptami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/75.jpg"),
    title: "Durga Puja",
    date: "17 October 2026",
    tithi: "Ashtami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/76.jpg"),
    title: "Maha Navami",
    date: "19 October 2026",
    tithi: "Navami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/77.jpg"),
    title: "Vijaya Dashami",
    date: "21 October 2026",
    tithi: "Dashami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/78.jpg"),
    title: "Valmiki Jayanti",
    date: "26 October 2026",
    tithi: "Purnima",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/79.jpg"),
    title: "Karwa Chauth",
    date: "30 October 2026",
    tithi: "Panchami",
    paksha: "Krishna"
  }
],
november: [
  {
    image: require("../../assets/image/Festival/80.jpg"),
    title: "Ahoi Ashtami",
    date: "1 November 2026",
    tithi: "Ashtami",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/81.jpg"),
    title: "Rama Ekadashi",
    date: "5 November 2026",
    tithi: "Ekadashi",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/82.jpg"),
    title: "Dhanteras",
    date: "6 November 2026",
    tithi: "Trayodashi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/83.jpg"),
    title: "Diwali",
    date: "8 November 2026",
    tithi: "Chaturdashi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/84.jpg"),
    title: "Govardhan Puja",
    date: "10 November 2026",
    tithi: "Pratipada",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/85.jpg"),
    title: "Bhai Dooj",
    date: "11 November 2026",
    tithi: "Dwitiya",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/86.jpg"),
    title: "Durgashtami Vrat",
    date: "17 November 2026",
    tithi: "Ashtami",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/87.jpg"),
    title: "Tulsi Vivah",
    date: "21 November 2026",
    tithi: "Dwadashi",
    paksha: "Shukla"
  }
],
december: [
  {
    image: require("../../assets/image/Festival/88.jpg"),
    title: "Kalbhairav Jayanti",
    date: "1 December 2026",
    tithi: "Ashtami",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/89.jpg"),
    title: "Indian Navy Day",
    date: "4 December 2026",
    tithi: "Ekadashi",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/90.jpg"),
    title: "Durgashtami Vrat",
    date: "17 December 2026",
    tithi: "Ashtami",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/91.jpg"),
    title: "National Consumer Day",
    date: "24 December 2026",
    tithi: "Pratipada",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/92.jpg"),
    title: "Christmas",
    date: "25 December 2026",
    tithi: "Dwitiya",
    paksha: "Shukla"
  },
  {
    image: require("../../assets/image/Festival/93.jpg"),
    title: "Sankashti Ganesh Chaturthi",
    date: "26 December 2026",
    tithi: "Tritiya",
    paksha: "Krishna"
  },
  {
    image: require("../../assets/image/Festival/94.jpg"),
    title: "Budha Ashtami Vrat",
    date: "30 December 2026",
    tithi: "Ashtami",
    paksha: "Krishna"
  }
],
};
